import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ExamResultsLayer from "../components/ExamResultsLayer";

const ExamResultsPage = () => {
  return (
    <MasterLayout>
      <ExamResultsLayer />
    </MasterLayout>
  );
};

export default ExamResultsPage;
